import {
  AboutContainer,
  AboutInformationWrapper,
  AboutWrapper,
  CardDescription,
  CardImageContainer,
  CardTitle,
  ContentContainer,
  FooterCTAContainer,
  FooterColumnWrapper,
  FooterImage,
  FooterImageContainer,
  GetStartedButton,
  GetStartedDescription,
  GetStartedTitle,
  GetStartedWrapper,
  InformationcardWrapper,
  SplashContentWrapper,
} from './styles'
import { AnalyticsArea, useAnalyticsEventTracker, useThemeBasedImage } from 'hooks'
import { aboutInformation } from './services'

import FOOTER_IMAGE from 'assets/about/splash-light.png'
import FOOTER_IMAGE_DARK from 'assets/about/splash-dark.png'
import { BASE_META_DESCRIPTION } from 'app-constants'
import GenericMetaTag from 'pages/overview/component/overview-meta-tags'

export const AboutPage: React.FC = () => {
  const imageSrc = useThemeBasedImage(FOOTER_IMAGE, FOOTER_IMAGE_DARK)

  const { navigationEvent } = useAnalyticsEventTracker(AnalyticsArea.About)
  return (
    <>
      <GenericMetaTag rightHandTitle="About" description={BASE_META_DESCRIPTION} pathname="about" />
      <ContentContainer>
        <AboutWrapper>
          <SplashContentWrapper>
            <h1>A crypto index platform to power the new age of finance </h1>
            <span>
              We create on-chain index funds and structured products so you can get exposure without
              the complexity
            </span>
          </SplashContentWrapper>
          <AboutInformationWrapper>
            {aboutInformation.map((item) => (
              <InformationcardWrapper key={item.title}>
                <CardImageContainer>{item.image}</CardImageContainer>
                <CardTitle>{item.title}</CardTitle>
                <CardDescription>{item.description}</CardDescription>
              </InformationcardWrapper>
            ))}
          </AboutInformationWrapper>
        </AboutWrapper>
      </ContentContainer>
      <FooterCTAContainer>
        <AboutContainer>
          <FooterColumnWrapper>
            <GetStartedWrapper>
              <GetStartedTitle>Ready to get started?</GetStartedTitle>
              <GetStartedDescription>
                Check out our investment products and begin investing the smarter way
              </GetStartedDescription>
              <GetStartedButton buttonType="primary" onClick={() => navigationEvent('/#content')}>
                View products
              </GetStartedButton>
            </GetStartedWrapper>
            <FooterImageContainer>
              <FooterImage src={imageSrc} />
            </FooterImageContainer>
          </FooterColumnWrapper>
        </AboutContainer>
      </FooterCTAContainer>
    </>
  )
}
